import React, { useState } from 'react';
import Header from '../../../layouts/doctor/DoctorHeader';
import { Reviewtable } from './Reviewtable';


export const Review = () => {
    const [search, setSearch] = useState("");
    const [update, setUpdate] = useState(false);

   


const handleSearchChange = (event) => {
    setSearch(event.target.value); 
};

const handleUpdate = () => {
    setUpdate((prev) => !prev); 
  };
   
    
    return (
        <div>
            <Header pageTitle="Reviews" />
            <div className="cardOuter">
                <div className="cardheads">
                    <div className="cardTitle">
                       Reviews
                    </div>
                    <button className="btn blackoutlineBtn" onClick={handleUpdate}>Refresh</button>
                </div>
                <div className="cardcontents">
                    <div className="tabpanelControl mt-3">
                    <div className="topsearchs">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="searchBar">
                              <input 
                                type="text" 
                                autoComplete='off' 
                                placeholder='Search'
                                value={search}
                                onChange={handleSearchChange} 
                            />
                            </div>
                            
                        </div>
                  <Reviewtable search={search} update={update} setUpdate={setUpdate}/>
                </div>
            </div>
            </div>
        </div>
       
        </div>
    )
}
